
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://azfvvzbppfbjozelxxmb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6ZnZ2emJwcGZiam96ZWx4eG1iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxNTY4NjgsImV4cCI6MjA2MjczMjg2OH0.vy3nDxl-JjmHJir3O14ZuTtCDykGetCxUZYuw9xFnyk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
